/**
 * Detect kringen that the AutoCAD extraction dropped.
 *
 * The extraction numbers kringen 1..N. A healthy collector therefore has every
 * integer from 1 to its highest kringnummer present. A GAP in that run means the
 * extraction silently lost a kring (e.g. 1, 2, 4, 5 → kring 3 is missing).
 *
 * `findKringGaps` returns the missing numbers ascending; an empty array means the
 * sequence is complete (or there are no kringen at all).
 *
 * Known limit: a dropped LAST kring (have 1..6, should have had 8) leaves no gap
 * and cannot be detected from the sequence alone. The CAD JSON's declared
 * `Kringen` count would catch that, but it is not persisted in Odoo today, so the
 * dashboard cannot see it for already-imported collectors. Igor accepted this —
 * the interior/leading gap is the case that actually occurs.
 */
export function findKringGaps(kringNumbers: number[]): number[] {
  const present = new Set<number>();
  let max = 0;
  for (const n of kringNumbers) {
    if (!Number.isInteger(n) || n < 1) continue;
    present.add(n);
    if (n > max) max = n;
  }
  if (max === 0) return [];

  const gaps: number[] = [];
  for (let i = 1; i < max; i++) {
    if (!present.has(i)) gaps.push(i);
  }
  return gaps;
}

/** Dutch label for a gap list, e.g. "Kring 3 ontbreekt" / "Kringen 3, 5 ontbreken". */
export function formatKringGaps(gaps: number[]): string {
  if (gaps.length === 0) return '';
  if (gaps.length === 1) return `Kring ${gaps[0]} ontbreekt`;
  return `Kringen ${gaps.join(', ')} ontbreken`;
}
